import script from "./TheDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./TheDatePicker.vue?vue&type=style&index=0&id=c38fa7ba&scoped=true&lang=scss"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c38fa7ba"]])

export default __exports__